import { EDITOR_TOGGLE_EMAIL_SETTING } from './constants';

export function toggleEmailSetting(args) {
  return {
    type: EDITOR_TOGGLE_EMAIL_SETTING,
    data: args ? args.snippet : null,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_TOGGLE_EMAIL_SETTING:
      return {
        ...state,
        showEmailSetting: !state.showEmailSetting,
        selectedSnippet: action.data ? action.data : null,
        showBuilderCanvasLoader: !state.showBuilderCanvasLoader,
      };

    default:
      return state;
  }
}
